import { isWorkflowOverviewGroup } from '../predicates'
import type {
  WorkflowOverviewItem,
  WorkflowOverviewGroup,
} from '@app/application/workflow-overview-navigation/types'

import { useDropdown } from '@app/shared/pinia/dropdown'
import { useWorkflowReviewFocus } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-focus'

/**
 * @description Recursively finds the correct review item index ref to focus.
 * In case of groups, it will exhaust the children hierarchy and return the index ref of the first child instead.
 * @param item - The overview tree menu item that was clicked
 * @returns - The review item index to focus
 */
function findIndexRef(
  item: WorkflowOverviewItem | WorkflowOverviewGroup
): number {
  if (!item) {
    return -1
  }

  if (isWorkflowOverviewGroup(item)) {
    return findIndexRef(item.children[0])
  }

  return item.reviewIndex
}

export default function useOverviewMenuClick(): {
  treeMenuItemClicked: (
    item: WorkflowOverviewItem | WorkflowOverviewGroup
  ) => void
} {
  const focusStore = useWorkflowReviewFocus()
  const dropdownStore = useDropdown()

  function treeMenuItemClicked(
    item: WorkflowOverviewItem | WorkflowOverviewGroup
  ): void {
    const itemIndexToFocus = findIndexRef(item)

    if (itemIndexToFocus !== -1) {
      focusStore.triggerNextReviewItemFocus(itemIndexToFocus)
    }

    dropdownStore.closeDropdown()
  }

  return {
    treeMenuItemClicked,
  }
}
